/**
 * @generated SignedSource<<b8fb7cd61e0c3c91e1799c4578a1b645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveUpdateSwitchLiveArticleLiveArticle$data = {
  readonly pushNotifications: boolean | null;
  readonly status: boolean | null;
  readonly " $fragmentType": "liveUpdateSwitchLiveArticleLiveArticle";
};
export type liveUpdateSwitchLiveArticleLiveArticle$key = {
  readonly " $data"?: liveUpdateSwitchLiveArticleLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveUpdateSwitchLiveArticleLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveUpdateSwitchLiveArticleLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pushNotifications",
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "89347949181a583534a1baac87d56917";

export default node;
